import configure from "configure"

// Uploaded images live on both servers: components point at the Laravel path,
// and any that fail to load there are retried once from the Node uploads path.
export const setupImageFallback = () => {
  window.addEventListener(
    "error",
    e => {
      const img = e.target
      if (!(img instanceof HTMLImageElement)) return
      if (!img.src.startsWith(configure.imgUrl)) return

      // Hold back the component's own onError (default logo / hide) until Node has failed too
      e.stopPropagation()
      const path = img.src.slice(configure.imgUrl.length).replace(/^\/+/, "")
      img.src = `${configure.nodeImgApi}/${path}`
    },
    true // error events don't bubble, so listen in the capture phase
  )
}
